const CONSENT_VERSION = 3;

const CATEGORIES = ['essential', 'functional', 'analytics', 'marketing'];

const STORAGE_KEY = 'mgr_cookie_consent';

const EVENT_NAME = 'mgr:consent-updated';

let _store = null;

const _callbacks = {};

function _migrateCategories(data) {
    if (!data || !data.categories) return null;

    if (data.version === 2) {
        const marketing = !!data.categories.marketing;
        return {
            essential: true,
            functional: !!data.categories.functional,
            analytics: marketing,
            marketing: marketing,
        };
    }

    if (data.version !== CONSENT_VERSION) return null;

    return data.categories;
}

function _read() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        const categories = _migrateCategories(data);
        if (!categories) return null;
        return { ...data, categories: categories, version: CONSENT_VERSION };
    } catch (e) {
        return null;
    }
}

function _write(categories) {
    const data = {
        version: CONSENT_VERSION,
        categories: categories,
        timestamp: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function _dispatch(categories) {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: categories }));

    if (_store) {
        _store.commit('setConsent', categories);
    }
}

function _fireReady(category, categories) {
    if (category === 'essential' || categories[category] === true) {
        const cbs = _callbacks[category] || [];
        cbs.forEach(fn => { try { fn(); } catch (e) { console.error('[ConsentUtil] onReady callback error:', e); } });
        _callbacks[category] = [];
    }
}

export default {

    // Consent is required only when explicitly enabled (1). Missing or 0 = opt-out.
    isRequired() {
        return parseInt(window.cookie_consent, 10) === 1;
    },

    init(store) {
        _store = store || null;

        if (!this.isRequired()) {
            if (_store) {
                _store.commit('setConsent', null);
                _store.commit('setShowCookieBanner', false);
            }
            return;
        }

        const data = _read();

        if (_store) {
            _store.commit('setConsent', data ? data.categories : null);
            _store.commit('setShowCookieBanner', !data);
        }

        if (data) {
            CATEGORIES.forEach(cat => _fireReady(cat, data.categories));
        }

        window.addEventListener(EVENT_NAME, (e) => {
            const categories = e.detail;
            CATEGORIES.forEach(cat => _fireReady(cat, categories));
        });
    },

    getConsent() {
        return _read();
    },

    setConsent(categories) {
        _write(categories);
        _dispatch(categories);
        if (_store) {
            _store.commit('setShowCookieBanner', false);
        }
    },

    hasConsent(category) {
        if (category === 'essential') return true;
        if (!this.isRequired()) return false;
        const data = _read();
        if (!data) {
            // No stored consent yet — functional is on by default (opt-out model).
            return category === 'functional';
        }
        return !!(data.categories && data.categories[category] === true);
    },

    acceptAll() {
        const all = {};
        CATEGORIES.forEach(cat => { all[cat] = true; });
        this.setConsent(all);
    },

    rejectAll() {
        const rejected = {};
        CATEGORIES.forEach(cat => { rejected[cat] = cat === 'essential' || cat === 'functional'; });
        this.setConsent(rejected);
    },

    isBannerNeeded() {
        if (!this.isRequired()) return false;
        return !_read();
    },

    onReady(category, callback) {
        if (category === 'essential') {
            callback();
            return;
        }
        if (!this.isRequired()) return;
        if (this.hasConsent(category)) {
            callback();
            return;
        }
        if (!_callbacks[category]) _callbacks[category] = [];
        _callbacks[category].push(callback);
    },

};
